"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CAMBRIDGE_CREDIT_COUNSELING = exports.WAJDA_ASSOCIATES = exports.UPSOLVE = exports.NEELEY_LAW = exports.MONEY_MANAGEMENT_INTERNATIONAL = exports.LINCOLN_LAW = exports.LEGAL_ZOOM = exports.ICE_LEGAL = exports.HOGLUND_LAW = exports.FAIRMAX_LAW = exports.BRIDGE_LEGAL = exports.BOND_BOTES = exports.ATLAS_LAW = void 0; // TODO: Stop doing customer consts in the shared pkg lol

exports.ATLAS_LAW = "atlasLaw";
exports.BOND_BOTES = "bondBotes";
exports.BRIDGE_LEGAL = "bridgeLegal";
exports.FAIRMAX_LAW = "fairmaxLaw";
exports.HOGLUND_LAW = "hoglundLaw";
exports.ICE_LEGAL = "iceLegal";
exports.LEGAL_ZOOM = "legalZoom";
exports.LINCOLN_LAW = "lincolnLaw";
exports.MONEY_MANAGEMENT_INTERNATIONAL = "moneyManagementInternational";
exports.NEELEY_LAW = "neeleyLaw";
exports.UPSOLVE = "upsolve";
exports.WAJDA_ASSOCIATES = "wajdaAssociates";
exports.CAMBRIDGE_CREDIT_COUNSELING = "cambridge";